import { render, staticRenderFns } from "./DetailBilling.vue?vue&type=template&id=04ef1336&scoped=true&"
import script from "./DetailBilling.vue?vue&type=script&lang=js&"
export * from "./DetailBilling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ef1336",
  null
  
)

export default component.exports